import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const TriangleUp: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    // Solid icon, no stroke.
    return (
        <IconSVG stroke="0" fill="none" {...props}>
            <IconPath
                d="M18.1582 13.8182C18.5597 14.3859 18.1537 15.1702 17.4584 15.1702H12.0849L6.71139 15.1702C6.01608 15.1702 5.61013 14.386 6.01145 13.8183L11.3847 6.21859C11.7263 5.7355 12.4429 5.7355 12.7845 6.21842L18.1582 13.8182Z"
                fill="currentColor"
                {...pathProps}
            />
        </IconSVG>
    );
};
